import { writable } from 'svelte/store';
import { browser } from '$app/environment';

const token = writable(browser && localStorage.getItem('token'));

token.subscribe((value) => {
	if (browser && value) return localStorage.setItem('token', value);
});

export default token;
